import DefaultLockPaywall from './DefaultLockPaywall';
import ExperimentalLockPaywall from './ExperimentalLockPaywall';
import OptimizelyExperiment from '../optimizely';
import { OPTIMIZELY_AUDIT_TRIAL_EXPERIMENT } from '../data/optimizely';

const LockPaywall = (props) => (
  <OptimizelyExperiment
    defaultComponent={DefaultLockPaywall}
    experimentalComponent={ExperimentalLockPaywall}
    defaultVariationKey="off"
    experimentKey={OPTIMIZELY_AUDIT_TRIAL_EXPERIMENT.KEY}
    {...props}
  />
);

export default LockPaywall;
